module.exports = __webpack_public_path__ + "img/banner3.bdf9eb64.jpg";